export default __webpack_public_path__ + "static/PEPESTENCIL-c90318423f71d4855c0641b9cbbb53d6.jpg";